<template>
  <div class="payment-details" redesign>
    <!-- Header -->
    <NomineeProgressBar v-if="employeeCode"
      stepName="Payment Details"
      :stepNumber=6
      :numberOfSteps=6
    />
    <NomineeProgressBar v-else
      stepName="Payment Details"
      :stepNumber=4
      :numberOfSteps=4
    />

    <div class="form-container payment-details-form">
      <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
      <template v-if="!loading">
        <!-- Payment selection -->
        <!--
        <div class="form-field">
          <h4 class="form-field-header">
            * Select how you would like to be paid:
          </h4>
          <div class="form-field-container">
            <select v-model="paymentChoice">
              <option v-for="option in paymentChoices" :value="option">{{ option }}</option>
            </select>
            <span class="form-dropdown" />
          </div>
        </div>
        -->

        <template v-if="paymentChoice === 'Paypal'">
          <div class="form-field card-shape">
            <FormTextField
              label="Email address used to log in to PayPal"
              helpText="example@email.com"
              :value.sync="paypalEmail"
              :showErrorMessage="showFieldErrors && fieldErrorMessage('paypalEmail') !== ''"
              :errorMessage="fieldErrorMessage('paypalEmail')"
            />
          </div>
        </template>

        <!-- Check by mail -->
        <!--
        <template v-if="paymentChoice === 'Check by mail'">
          <div class="form-field">
            <h4 class="form-field-header">
              * Enter your mailing address:
            </h4>
            <div class="form-field-container">
              <textarea class="form-field-text" />
            </div>
          </div>
        </template>
        -->

        <SubmitButton
          class="form-button-160"
          :onContinue="updatePayPalEmail"
          buttonText="Submit"
          :staticWidth="true"
          :noNavigation="true"
          :darkText="true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import NomineeProgressBar from '@/components/stepper/NomineeProgressBar'
import FormTextField from '@/components/forms/FormTextField'
import SubmitButton from '@/components/requests/SubmitButton'

import Employee from '@/services/employees'
import NomineesApi from '@/services/nominees'

export default {
  name: 'NomineeOnboardingPaymentDetails',
  components: {
    LoadSpinner,
    NomineeProgressBar,
    FormTextField,
    SubmitButton,
  },
  data() {
    return {
      loading: true,
      employeeCode: null,
      //paymentChoices: ['Paypal', 'Check by mail'],
      paymentChoice: 'Paypal',
      paypalEmail: '',
      showFieldErrors: false,
    }
  },
  async created() {
    this.employeeCode = this.$route.params.code

    const stipendRequest = await NomineesApi.createOrGetStipendRequest({ program_month: 1 })
    await this.$store.dispatch('updateCurrentRequest', stipendRequest)
  },
  mounted() {
    if(this.user.paypalEmail) {
      this.paypalEmail = this.user.paypalEmail
    }
    this.loading = false
  },
  methods: {
    fieldErrorMessage(field) {
      let errorMessage = ''

      if (this.errors && this.errors.length > 0) {
        let results = this.errors.filter(error => error.field == field)
        if (results && results.length > 0) {
          errorMessage = results[0].message
        }
      }

      return errorMessage
    },
    async updatePayPalEmail() {
      // Reset errors before hitting API again
      this.errors = []

      // Client-side error handling - i.e. make sure it's not blank
      if (!this.paypalEmail) {
        this.errors.push({
          field: 'paypalEmail',
          message: this.$gettext('Valid email required.'),
        })
        this.showFieldErrors = true
        this.eventsTracker('paypal-email-submission', 'paypal_email: no email provided.')
        return Promise.reject('valid-email-required')
      }

      // Prep object and send to API
      this.loading = true
      const employee = Employee.create({
        ...this.user,
        paypalEmail: this.paypalEmail,
      })
      const updateFields = ['paypalEmail']
      Employee.api
        .update(employee, updateFields)
        .then((employee) => this.$store.dispatch('updateUser', employee))
        // Format server-side error messages
        // TODO: Not sure how well this plays with 500 errors
        .catch((err) => {
          this.eventsTracker('paypal-email-submission', err.response.data)
          this.errors.push({
            field: 'paypalEmail',
            message: objectToCamelCase(err.response.data)['paypalEmail'][0],
          })
          this.showFieldErrors = true

          console.log(err)
          return Promise.reject('paypal-email-update-error')
        })

        await NomineesApi.submitStipendRequest(this.currentRequest.id)

        this.$router.push({ name: 'NomineeHome' })
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars', 'currentRequest']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.payment-details {
  display: flex;
  flex-direction: column;

  .payment-details-form {
    @extend .constrain-tablet-and-up;

    @media (min-width: 1140px) {
      max-width: 1076px !important;
    }
  }

  .card-shape {
    max-width: 453px;
    width: 100%;
    align-self: center;

    @include tablet-and-up-screen {
      padding: 2.5rem;
    }

    .form-field {
      margin-bottom: 0;
    }
  }
}
</style>
